import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { TextFieldComponent } from "../text-field/text-field.component";
import { MatAutoSearchService } from "../mat-auto-search/mat-auto-search.service";
import { debounceTime, distinctUntilChanged, map, of, BehaviorSubject, startWith, filter as rxjx_filter } from "rxjs";
import { filter } from 'src/app/pages/apps/mailbox/listing/categories';

@Component({
    selector: 'app-edit-suggestion-field',
    templateUrl: './edit-suggestion-field.component.html',
    styleUrls: ['../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => EditSuggestionFieldComponent),
        }
    ]
})
export class EditSuggestionFieldComponent extends TextFieldComponent implements OnInit {

    @Input()
    options = [];

    @Input()
    listUrlTransforms: Object = {};

    @Input()
    optionsPageNum = 1;

    @Input()
    optionsPageSize = 10;

    @Input()
    displayField: string = 'name';

    @Input()
    hintText = 'These items already exists. Click to edit.';

    @Input()
    itemIcon = 'flaticon-pencil-tool';

    // _listUrl: string = null;
    // @Input()
    // get listUrl(): string {
    //     return this._listUrl;
    // }

    // set listUrl(value: string) {
    //     this._listUrl = value;
    //     if (this.listUrl != null && this.isEditable) {
    //         this.setOptionList('');
    //     }
    // }
    @Input()
    listUrl: string;

    @Input()
    searchTextMinLength = 2;

    @Output()
    onSelect = new EventEmitter<any>();

    @Output()
    override focusOut = new EventEmitter<any>();

    @Input()
    checkFieldValidity: boolean = false;

    dataChange = new BehaviorSubject('');

    loading = false;
    showOptions = false;
    isFocused = true

    constructor(private autoSearchService: MatAutoSearchService) {
        super();
    }

    override ngOnInit() {

        this.dataChange.pipe(
            map(term => { return term }),
            debounceTime(500),
            distinctUntilChanged(),
            startWith(''),
            rxjx_filter(searchTerm => {
                if (searchTerm.length <= this.searchTextMinLength) {
                    this.showOptions = false;
                }
                return searchTerm.length > this.searchTextMinLength
            }),
            map(searchTerm => {
                this.setOptionList(searchTerm);
            })
        ).subscribe();
        super.ngOnInit();
    }

    setOptionList(searchTerm) {
        this.loading = true;

        if (this.listUrl == null) {

            if (this.options == null) {
                console.error("No options provided");
            }

            this.loading = false;
            return;
        }

        let transforms = { ...this.listUrlTransforms }
        transforms['search'] = searchTerm;

        let url = new URL(this.applyUrlTransforms(this.listUrl, transforms));
        if (this.optionsPageNum != null) {
            url.searchParams.append('page', String(this.optionsPageNum));
        }
        if (this.optionsPageSize != null) {
            url.searchParams.append('page_size', String(this.optionsPageSize));
        }

        this.autoSearchService.listObjects(String(url)).subscribe((response) => {

            this.options = response.results;
            this.loading = false;
            this.showOptions = true
        });
    }

    setData(data) {
        console.debug('aaya', data);
        this.data = data;
        this.dataChange.next(data);
    }

    onOptionSelected(option) {
        this._data = option[this.displayField];
        this.onSelect.emit(option);
        this.showOptions = false;
    }

    onFocusOut(event) {

        this.isFocused = false;
        setTimeout(() => {
            if (!this.isFocused) {
                this.checkForValidity()
                this.showOptions = false;
                this.options = []
            }
        }, 500)
    }

    onFocusIn(event) {
        this.isFocused = true
        this.showOptions = true;
    }

    checkForValidity() {
        if (this.checkFieldValidity) {
            this.focusOut.emit()
        }
    }

}
